import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

export default function FormattedMessage(props: { id: string }): ReactElement {
  const { t } = useTranslation();
  return t(props.id);
}
